<template>
  <div class="surface-0 shadow-2 px-3 py-2 flex align-items-center justify-content-between navbar">
    <div class="flex align-items-center">
      <img src="@/assets/logo.svg" alt="logo" class="h-4" />
    </div>

    <Button
      icon="pi pi-bars"
      class="p-button-text p-button-primary md:hidden"
      @click="menuOpen = true"
    />

    <div class="hidden md:flex align-items-center gap-3">
      <RouterLink to="/">
        <Button label="Home" icon="pi pi-home" class="p-button-text" />
      </RouterLink>
      <!-- Uncomment when needed
      <RouterLink to="/contact">
        <Button label="Contact" icon="pi pi-envelope" class="p-button-text" />
      </RouterLink>
      -->
      <Button
        label="Start Building"
        icon="pi pi-play"
        class="p-button-rounded p-button-primary"
        @click="openApp"
      />
    </div>
  </div>

  <Drawer v-model:visible="menuOpen" position="right" class="w-38">
    <div class="flex flex-col h-full dark-mode">
      <Menu :model="menuItems" class="border-none w-full" />
    </div>
  </Drawer>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import Button from 'primevue/button'
import Drawer from 'primevue/drawer'
import Menu from 'primevue/menu'
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()
const route = useRoute()

const menuOpen = ref(false)

const menuItems = [
  {
    label: 'Home',
    icon: 'pi pi-home',
    command: () => {
      router.push('/')
      menuOpen.value = false
    },
  },
  // Uncomment when needed
  // {
  //   label: 'Contact',
  //   icon: 'pi pi-envelope',
  //   command: () => {
  //     router.push('/contact')
  //     menuOpen.value = false
  //   },
  // },
  {
    label: 'Start',
    icon: 'pi pi-play',
    command: () => {
      menuOpen.value = false
      window.location.href = window.__APP_CONFIG__.APP_START_URL
    },
  },
]

watch(
  () => route.fullPath,
  () => {
    menuOpen.value = false
  },
)

const openApp = () => {
  menuOpen.value = false
  window.location.href = window.__APP_CONFIG__.APP_START_URL
}
</script>

<style scoped>
.navbar {
  width: 100vw;
  position: sticky;
  top: 0;
  z-index: 1000;
}

a:hover {
  cursor: pointer;
}
</style>
